
(function () {
  $('#itemList').on('click', 'li', function (e) {
    var url = $(this).data('url')
    if (!url) return;
    window.location.href = url;
  })
})()